<template>
    <div>
        <slot/>
        <b-row v-if="paymentMethods">
            <b-col :sm="fullWidth ? 12 : 6" :lg="fullWidth ? 12 : 4" cols="12" v-for="paymentMethod in paymentMethods"
                   :key="paymentMethod.id"
                   class="mt-3">
                <div class="w-100 border rounded p-2 d-flex align-items-center justify-content-between payment-method-card"
                     v-if="paymentMethod.card" :class="{'selectable': canSelect}" @click="selectMethod(paymentMethod)">
                    <em class="mr-2" :class="getBrandIconClass(paymentMethod.card.brand)"></em>
                    <span class="d-flex align-items-center text-2xl">**** **** **** {{paymentMethod.card.last4}}
                    <small class="ml-2 small text-sm badge badge-warning">{{paymentMethod.card.exp_month}} / {{paymentMethod.card.exp_year}}</small>
                </span>

                    <b-button variant="outline-danger" v-b-modal="'modal-' + paymentMethod.id" class="d-flex self-end"
                              v-if="canDelete"
                              style="border: none !important;"><em class="fa fa-trash"></em></b-button>
                    <em class="d-flex self-end fa-2x far fa-square"
                       v-if="canSelect && selectedMethodId !== paymentMethod.id"></em>
                    <em class="d-flex self-end fa-2x fas fa-check-square text-success"
                       v-if="canSelect && selectedMethodId === paymentMethod.id"></em>
                </div>
                <!-- confirm delete payment method modal -->
                <b-modal :id="'modal-' + paymentMethod.id" centered hide-header v-if="canDelete">
                    <h2 class="text-center">{{$t('user.payment_method_delete_modal.are_you_sure')}}</h2>
                    <template v-slot:modal-footer="{ close }">
                        <div class="w-100 d-flex justify-content-center">
                            <b-button class="btn mr-2" variant="secondary" @click="close()">
                                {{$t('user.payment_method_delete_modal.cancel')}}
                            </b-button>
                            <b-button class="btn" variant="primary" @click="deletePaymentMethod(paymentMethod)">
                                {{$t('user.payment_method_delete_modal.delete')}}
                            </b-button>
                        </div>
                    </template>
                </b-modal>
            </b-col>
            <b-col :sm="fullWidth ? 12 : 6" :lg="fullWidth ? 12 : 4" cols="12" class="mt-3 align-items-end d-grid"
                   v-if="canAdd">
                <b-button variant="outline-primary" @click="startCheckout">{{$t('user.add_payment_method')}}</b-button>
            </b-col>
        </b-row>

        <b-row v-else class="blurred p-3">
            <b-col :sm="fullWidth ? 12 : 6" :lg="fullWidth ? 12 : 4" cols="12" v-for="i in (fullWidth ? 3 : 6)" :key="i"
                   class="mt-3">
                <div class="w-100 border rounded p-2 d-flex align-items-center justify-content-between ">
                    <em class="mr-2" :class="getBrandIconClass('stripe')"></em>
                    <span class="d-flex align-items-center text-2xl">**** **** **** {{i}}{{i}} {{i}}{{i}}
                    <small class="ml-2 small text-sm badge badge-warning">{{i}}{{i}} / {{i}}{{i}}</small>
                </span>

                    <b-button variant="outline-danger" class="d-flex self-end" v-if="canDelete"
                              style="border: none !important;"><em class="fa fa-trash"></em></b-button>
                    <em class="d-flex self-end far fa-square" v-if="canSelect"></em>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {errors} from "../../mixins/errors";
    import api from "../../api/user";
    import {notifications} from '../../mixins/notifications';
    import {mapGetters} from 'vuex';

    export default {
        name: 'payment-methods',
        mixins: [errors, notifications],
        props: {
            fullWidth: {
                type: Boolean,
                default: false
            },
            canAdd: {
                type: Boolean,
                default: true
            },
            canDelete: {
                type: Boolean,
                default: true
            },
            canSelect: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.$store.dispatch('user/loadPaymentMethods');
        },
        data() {

            return {
                stripe: null,
                selectedMethodId: null
            }
        },
        computed: {
            ...mapGetters({
                paymentMethods: 'user/paymentMethods',
            }),
        },
        methods: {
            startCheckout() {
                api.getCheckoutSession(window.location.href).then(({session_id}) => {
                    this.stripe = Stripe(this.$root.stripePublicKey, {
                        locale: this.$root.lang
                    });
                    this.stripe.redirectToCheckout({
                        sessionId: session_id
                    }).then(function (result) {
                        if (result.error) {
                            this.pushNotification(result.error.message, 'danger');
                        }
                    });
                });
            },
            deletePaymentMethod(paymentMethod) {
                this.$store.dispatch('user/deletePaymentMethod', paymentMethod).then(() => {
                    this.pushNotification(this.$t('user.payment_method_deleted'), 'success');
                }).catch(e => {
                    this.handleResponseErrors(e);
                });
            },
            getBrandIconClass(brand) {
                if (_.includes(['visa', 'mastercard', 'jcb', 'discover', 'diners_club', 'amex', 'apple_pay', 'amazon_pay'], brand)) {
                    return 'fa-2x fab fa-cc-' + brand.replace('_', '-');
                }

                return 'fa-2x fab fa-cc-stripe';
            },
            selectMethod(method) {
                if (!this.canSelect) {
                    return;
                }
                if (this.selectedMethodId === method.id) {
                    return this.selectedMethodId = null;
                }
                this.selectedMethodId = method.id;
            }
        },
        watch: {
            selectedMethodId: {
                handler() {
                    this.$emit('input', this.selectedMethodId);
                }
            }
        }

    }
</script>

<style scoped>

</style>
